import { UserOutlined } from '@ant-design/icons';
import { Dropdown, Layout, Menu, Modal, Typography } from 'antd';
import type { MenuProps } from 'antd';
import type { ReactNode } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useIsSuperAdmin } from '../lib/me';
import { AotvLogo } from './AotvLogo';

const { Header, Content } = Layout;
const { Text } = Typography;

export function AppLayout({ children }: { children: ReactNode }) {
  const { session, setSession } = useAuth();
  const isSuperAdmin = useIsSuperAdmin();
  const navigate = useNavigate();
  const location = useLocation();

  const isTeam = session?.role === 'team';

  const segs = location.pathname.split('/');
  const selectedKey = segs[1] || 'events';

  const teamItems: MenuProps['items'] = [
    { key: 'events', label: <Link to="/events">Events</Link> },
    { key: 'speakers', label: <Link to="/speakers">Speakers</Link> },
    { key: 'slide-licenses', label: <Link to="/slide-licenses">Slide licenses</Link> },
    { key: 'streams', label: <Link to="/streams">Streams</Link> },
    { key: 'srt', label: <Link to="/srt">SRT</Link> },
  ];

  const speakerItems: MenuProps['items'] = [];

  const handleLogout = () => {
    Modal.confirm({
      title: 'Log out?',
      okText: 'Log out',
      cancelText: 'Cancel',
      onOk: () => {
        setSession(null);
        navigate('/login', { replace: true });
      },
    });
  };

  const dropdownItems: MenuProps['items'] = [
    ...(isSuperAdmin
      ? [
          {
            key: 'admin-users',
            label: <Link to="/admin-users">Admin users</Link>,
          },
          { type: 'divider' as const },
        ]
      : []),
    {
      key: 'logout',
      label: <Text type="secondary">Logout</Text>,
      onClick: handleLogout,
    },
  ];

  return (
    <Layout className="app-layout">
      <Header className="app-header">
        <Link to={isTeam ? '/events' : '/'} className="logo-link">
          <AotvLogo alt="AOTV" />
        </Link>
        <Menu
          mode="horizontal"
          selectedKeys={[selectedKey]}
          items={isTeam ? teamItems : speakerItems}
          className="header-nav"
        />
        {session && (
          <Dropdown menu={{ items: dropdownItems }} placement="bottomRight" arrow>
            <UserOutlined style={{ fontSize: 20, cursor: 'pointer' }} />
          </Dropdown>
        )}
      </Header>
      <Content className="app-content">{children}</Content>
    </Layout>
  );
}
